import { withIdleWrapper } from '@sravni/react-ugc/lib/WithIdleWrapper';

import { useSubscription } from '../../hooks/subscription';
import { useSubscriptionPopup } from '../../hooks/subscriptionPopup';

import { SubscriptionPopup } from './components/SubscriptionPopup';
import { useIdleSubscriptionTime } from './components/SubscriptionPopup/useIdleSubscriptionTime';

const SubscriptionPopupIdle = withIdleWrapper(SubscriptionPopup);

interface IdleSubscriptionPopupProps {
  subscriptionPopupState: [number, (value: number) => void];
}

export const IdleSubscriptionPopup = ({ subscriptionPopupState }: IdleSubscriptionPopupProps) => {
  const { userEmail, handleSubscriptionClick, canUserSubscribe, isEmailEditable } = useSubscription('Попап');
  const { whenPopupWasShown, isVisible, onVisible, onHide } = useSubscriptionPopup(subscriptionPopupState);

  const isEnoughTimeSinceLastPopup = useIdleSubscriptionTime(whenPopupWasShown, isVisible);

  if (!canUserSubscribe) return null;
  if (!isEnoughTimeSinceLastPopup) return null;

  return (
    <SubscriptionPopupIdle
      userEmail={userEmail}
      onSubscribe={handleSubscriptionClick}
      onVisible={onVisible}
      onHide={onHide}
      isEmailEditable={isEmailEditable}
    />
  );
};
